<template>
    <div class="container-fluid">
        <div class="row py-3">
            <div class="designRowOrga">
                <div class="h3Organization">
                    <h3>Organizations</h3>
                </div>
                <router-link class="text-decoration-none btn-container"
                             v-if="permissions.includes('create organization') && organizations.length > 0"
                             to="/create-organizations">
                    <span>Create Organization</span>
                </router-link>
            </div>

            <div class="tabcontent tabcontent-bark-mode">
                <div class="fullInputs mb-4 pt-3">
                    <div class="twoInputs">
                        <div class="btnInsideInput">
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search" autocomplete="off"
                                   @input="searchHandler" maxlength="50">

                            <button @click="searchBackEndHandler" ref="buttonSearch">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>
                    </div>
                    <div class="oneInput">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="getOrganizations">
                            <option selected disabled value="false">Sort by Date</option>
                            <option value="asc">Oldest</option>
                            <option value="desc">Latest</option>
                        </select>
                    </div>
                </div>
                <div class="table-container" v-if="organizations.length > 0">

                    <TableComponent :thead="thead" :tbody="organizations" @sort="SortOrganization" :keys="keys"
                                    model="organizations" name="organization"
                                    updateUrl="/edit-organizations" @update="updateOrganization"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getOrganizations" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                    <div class="h3Organization">
                        <h3 v-if="!isSearch">You Don't Have Any Organizations Yet</h3>
                        <h3 v-else>No Data</h3>
                    </div>
                    <router-link class="text-decoration-none btn-container  btn-container-no-data"
                                 v-if="permissions.includes('create organization') && organizations.length === 0 && !isSearch"
                                 to="/create-organizations">
                        <span>Create Organization</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import TableComponent from "../../components/TableComponent";
    import organization from "../../../api-services/organization";
    import LaravelVuePagination from 'laravel-vue-pagination';

    export default {
        name: 'organization-page',
        mounted() {
            this.permissions = this.$store.state.auth.permissions;
            this.getOrganizations();
            this.$store.dispatch('activeTap', 'organizations');
        },
        data() {
            return {
                thead: ['Organization Name', 'Admin Email'],
                keys: ['name', 'user_id'],
                permissions: [],
                organizations: [],
                filteredArray: [],
                originalOrganizations: [],
                laravelData: {},
                error: null,
                search: null,
                isSearch: false,
                sort: false,
                state: false
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        methods: {
            CreateOrganization() {
                this.$router.push({name: 'create-organization'});
            },
            getOrganizations: async function (page = 1) {

                try {
                    const response = await organization.index(this.search, this.sort === false ? this.sort = 'desc' : this.sort, page);
                    this.organizations = response.data.data;
                    this.laravelData = response.data;
                    this.originalOrganizations = response.data.data;

                } catch (e) {
                    console.log(e);
                    this.error = e;
                }

            },
            updateOrganization(e) {
                let filteredData = this.organizations.filter(function (data) {
                    return data.id != e;
                });
                this.organizations = filteredData;
                this.getOrganizations();

            },
            searchHandler(e) {
                this.isSearch = true;
            },
            async searchBackEndHandler() {
                await this.getOrganizations();
            },
            SortOrganization() {
                let status = !this.state;
                this.originalOrganizations.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            }
        }
    }
</script>

<style scoped>
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #DDD !important;
        opacity: 0.5 !important; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #DDD !important;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #DDD !important;
    }
</style>